import {logger} from 'tizra'
import {SsoSignIn} from './SsoSignIn'
import {TizraSignIn, TizraSignInProps} from './TizraSignIn'

const log = logger('AuthSignIn')

interface AuthSignInProps extends Omit<TizraSignInProps, 'authAgent'> {
  authAgent: TizraSignInProps['authAgent'] | 'sso'
}

export const AuthSignIn = ({authAgent, ...props}: AuthSignInProps) => {
  if (
    authAgent === 'sso' ||
    (authAgent === 'tizra' &&
      typeof window !== 'undefined' &&
      window.tizra.customLoginUrl)
  ) {
    return <SsoSignIn {...props} authAgent={authAgent} />
  }
  return <TizraSignIn {...props} authAgent={authAgent} />
}
